const aboutJuno = {
  title: "Image Generator - STUDIO JUNO",
  subtitle: "Welcome to STUDIO JUNO",
  description: "Enjoy a comfortable image generation experience with STUDIO JUNO",
  meta: {
    description:
      "AI that turns your ideas into beautiful images. Equipped with a wide range of functions from text to image generation to image editing. Even beginners can easily create high-quality images.",
  },
  section1: {
    title: "Generate any image or video you can imagine",
    t2i: {
      title: "Text to Image",
      description:
        "Generates images from text. Brings your ideas and concepts to life as beautiful, high-quality images.",
    },
    i2i: {
      title: "Image to Image",
      description:
        "Generates new target images based on source images. Create new images while maintaining common styles, themes and adjust similarity to your liking.",
    },
    upscale: {
      title: "Upscale and Enhance Image",
      description:
        "Upscales existing photos and illustrations to clear images, and enhances them by complementing missing pixels.",
    },
    edit: {
      title: "Edit Image",
      description: "Edit specific parts of an image, change the background, or expand the image dimensions.",
    },
    relight: {
      title: "Relight and Replace Background",
      description: "Change the lighting of an image or add new elements to the background.",
    },
  },
  section2: {
    title: "Infinite possibilities with a wide range of models",
    card1: {
      title: "Covering popular models",
      description:
        "Stimulate your creativity with a variety of models such as FLUX.1, Ideogram, and DALL-E with various styles and expressive power.",
    },
    card2: {
      title: "Latest and most innovative features",
      description: "Achieve higher quality results by utilizing the latest technologies and models such as AuraSR.",
    },
    card3: {
      title: "STUDIO JUNO exclusive models",
      description: "We offer models that can generate either life-like Japanese people or anime models.",
    },
  },
  section3: {
    title: "Turn your imagined images into reality in an instant.",
  },
  section4: {
    title: "Turn any image into a video using AI and your imagination.",
    subtitle: "From text to video, from image to video. Visualize your ideas as videos.",
    description: "STUDIO JUNO offers the world's leading video generation AI models",
  },
  try: "Try STUDIO JUNO",
};
export default aboutJuno;
